import { Component, ViewEncapsulation, ViewChild, TemplateRef, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { PaginationService } from 'src/app/PaginationService';
import { messageService } from 'src/app/message.service';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { qmsService } from '../qms.service';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { EditorComponent } from 'src/app/editor/editor.component';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
export interface PopupData {
  title: string;
}
@Component({
  selector: 'app-vendors',
  templateUrl: './vendors.component.html',
  styleUrls: ['./vendors.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class VendorsComponent implements OnDestroy, OnInit {

  isProcessing = true;
  dateCustomClasses: DatepickerDateCustomClasses[];
  isNavigatingToDetails: boolean = false;

  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, private readonly elem: ElementRef,
    public qmsService: qmsService) {

    const now = new Date();
    this.message.breadcrumbData.fourthLevel = 'Vendor';
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  }

  vendor: any = {};

  dropDownDataForGroups: any = [];
  dropDownDataForStatus: any = [];
  dropDownDataForOwnerShipType: any = [];
  dropDownDataForServiceLevelAgreement: any = [];
  dropDownForServicesOffered: any = [];

  groupDropdown: any = [];
  statusDropdown: any = [];
  ownerShipTypeDropdown: any = [];
  serviceLeverDropdown: any = [];
  servicesOfferedDropDown: any = [];

  selectedGroups: any = null;
  selectedStatus: any = null;
  selectedOwnerShipType: any = null;
  selectedServiceLevelAgreement: any = null;
  selectedServicesOffered: any = [];

  groupSearchText: string = '';
  statusSearchText: string = '';
  ownerShipSearchText: string = '';
  serviceLevelSearchText: string = '';
  servicesOfferedSearchText: string = '';

  oddGroup: any = null;
  oddStatus: any = null;
  oddOwnerShip: any = null;
  oddServiceLevel: any = null;
  oddServicesOffered: any = null;

  ngOnInit() {
    this.getCall();

    this.appService.getQmsGroups().subscribe((response1: any) => {
      this.dropDownDataForGroups = response1;
      this.selectBoxForGroups();
    });

    this.appService.getCodeListsByGroup("VENDOR_STATUS").subscribe((response2: any) => {
      this.dropDownDataForStatus = response2;
      this.selectBoxForStatus();
    })

    this.appService.getCodeListsByGroup("OWNERSHIP").subscribe((response3: any) => {
      this.dropDownDataForOwnerShipType = response3;
      this.selectBoxForOwnerShipType();
    })

    this.appService.getCodeListsByGroup("SERVICE_LEVEL_AGREEMENT").subscribe((response4: any) => {
      this.dropDownDataForServiceLevelAgreement = response4;
      this.selectBoxForServiceLevelAgreement();
    })

    this.appService.getCodeListsByGroup("VENDOR_SERVICES_OFFERED").subscribe((response4: any) => {
      this.dropDownForServicesOffered = response4;
      this.selectBoxForServicesOffered();
    })
  }

  ngOnDestroy() {
    if (this.isNavigatingToDetails) return; // If true, exit the function

    this.message.breadcrumbData.fourthLevel = '';
    this.isNavigatingToDetails = false;
  }

  selectBoxForGroups() {
    this.groupDropdown = [];
    this.groupDropdown = this.dropDownDataForGroups.map((item: { groupId: any; groupName: any; }) => ({
      valueExp: item.groupId,
      displayExp: item.groupName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim())) || []
  }

  selectBoxForStatus() {
    this.statusDropdown = [];
    this.statusDropdown = this.dropDownDataForStatus.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim())) || []
  }

  selectBoxForOwnerShipType() {
    this.ownerShipTypeDropdown = [];
    this.ownerShipTypeDropdown = this.dropDownDataForOwnerShipType.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim())) || []
  }

  selectBoxForServiceLevelAgreement() {
    this.serviceLeverDropdown = [];
    this.serviceLeverDropdown = this.dropDownDataForServiceLevelAgreement.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim())) || []
  }

  selectBoxForServicesOffered() {
    this.servicesOfferedDropDown = [];
    this.servicesOfferedDropDown = this.dropDownForServicesOffered?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim())) || []
  }

  validateNoOfDigitsFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  operationFlag: any;
  popupDataTitle: PopupData = {
    title: ''
  };

  popupTitle: string | null = 'title';
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  deletePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  dateFormat: any = this.appService.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  datePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }

  refreshGridData() {
    this.getCall();
  }

  validateVendorCode(event: KeyboardEvent) {
    const allowedCharactersRegex = /^[a-zA-Z0-9]*$/;
    const inputChar = event.key;

    if (!allowedCharactersRegex.test(inputChar)) {
      event.preventDefault();
    }
  }

  onPaste(event: ClipboardEvent): void {
    const pastedText = event.clipboardData?.getData('text');
    const allowedCharactersRegex = /^[a-zA-Z0-9]*$/;

    if (pastedText && !allowedCharactersRegex.test(pastedText)) {
      event.preventDefault();
      alert("Sorry! Copied content contains special characters")
    }
  }

  visibleAddButton: boolean;
  visibleEditButton: boolean;
  visibleReasonForUpdateField: boolean;

  openAddPopup() {
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.visibleReasonForUpdateField = false;
    this.operationFlag = 'ADD';
    this.popupDataTitle.title = "Create Vendors";
    [
      this.selectedStatus,
      this.selectedOwnerShipType,
      this.selectedServiceLevelAgreement,
      this.selectedServicesOffered
    ] = [null, null, null, []];

    this.vendor = {};
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  previousData: any;
  previousDataVendorId: any;
  filteredGroupsValue: any;
  filteredStatusValue: any;
  filteredOwnerShipTypeValue: any;
  filteredServiceLevelAgreementValue: any;
  openEditPopup(editRowData: any, editFlag: boolean, idx: number) {
    if (idx === 0 || editFlag) {
      if (idx == 0) {
        this.navigate(editRowData);
      } else {
        this.isProcessing = true;
        this.previousData = editRowData;
        this.visibleReasonForUpdateField = true;

        if (editFlag) {
          this.visibleAddButton = false;
          this.visibleEditButton = true;
          this.operationFlag = 'EDIT';
          this.popupDataTitle.title = "Update Vendors";
        } else {
          this.visibleAddButton = false;
          this.visibleEditButton = false;
          this.popupDataTitle.title = "Info";
        }

        this.previousDataVendorId = editRowData.VENDOR_ID;
        this.appService.getQmsVendorsVwDetailsByVendorId(editRowData.VENDOR_ID).subscribe((vendor: any) => {

          vendor.ndaSignedDate = vendor.ndaSignedDate ? new Date(vendor.ndaSignedDate) : null;
          vendor.nextAuditDate = vendor.nextAuditDate ? new Date(vendor.nextAuditDate) : null;
          vendor.lastAuditDate = vendor.lastAuditDate ? new Date(vendor.lastAuditDate) : null;
          this.selectedServicesOffered = vendor.servicesOffered ? vendor.servicesOffered.split(',') : [];


          if (vendor.status) {
            const matchingStatus = this.dropDownDataForStatus?.find((item: any) => item.codelistCode == vendor.status);
            if (!matchingStatus) {
              this.oddStatus = vendor.status;
              this.statusDropdown.push({
                valueExp: vendor.status,
                displayExp: vendor.status
              })
            }
            this.selectedStatus = vendor.status;
          }

          if (vendor.ownershipType) {
            const matchingOwnerShipType = this.dropDownDataForOwnerShipType?.find((item: any) => item.codelistCode == vendor.ownershipType);
            if (!matchingOwnerShipType) {
              this.oddOwnerShip = vendor.ownershipType;
              this.ownerShipTypeDropdown.push({
                valueExp: vendor.ownershipType,
                displayExp: vendor.ownershipType
              })
            }
            this.selectedOwnerShipType = vendor.ownershipType;
          }

          if (vendor.serviceLevelAgreement) {
            const matchingServiceLevelAgreement = this.dropDownDataForServiceLevelAgreement?.find((item: any) => item.codelistCode == vendor.serviceLevelAgreement);
            if (!matchingServiceLevelAgreement) {
              this.oddServiceLevel = vendor.serviceLevelAgreement;
              this.serviceLeverDropdown.push({
                valueExp: vendor.serviceLevelAgreement,
                displayExp: vendor.serviceLevelAgreement
              })
            }
            this.selectedServiceLevelAgreement = vendor.serviceLevelAgreement;
          }

          this.vendor = vendor;
          this.isProcessing = false;
          this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
        })
      }
    }
  }

  navigate(editRowData: any) {
    this.isNavigatingToDetails = true;
    this.router.navigate(['dashboard/vendorDetails'], {
      state: { vendorDetails: editRowData }
    });
  }

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;

    field && (field.style.color = items ? '#005c8a' : 'red');
    !field && console.error('Unable to find the element. [onNgModelChange()] Id → ', fieldId);
  }

  fieldValidation(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;

      element && (element.style.color = 'red');
      !element && console.error('Unable to find the element. [fieldValidation()] Id → ', elementId);
    });
  }

  addEdit(vendor: any) {

    const validations = [
      { condition: !vendor.vendorCode, id: 'vendor-code' },
      { condition: !vendor.vendorName, id: 'vendor-name' },
    ]

    const invalidIds = validations.filter((validation) => validation.condition).map((validation) => validation.id);

    if (invalidIds.length > 0) {
      this.fieldValidation(invalidIds);
      this.showSnackBar('Please enter all Mandatory Fields!', 'E');
    } else {
      this.isProcessing = true;

      let obj = {
        vendorId: this.vendor.vendorId,
        vendorName: this.vendor.vendorName,
        address: this.vendor.address,
        vendorCode: this.vendor.vendorCode,
        servicesOffered: this.selectedServicesOffered.length ? this.selectedServicesOffered?.join(',') ?? null : null,
        yearEstablished: this.vendor.yearEstablished,
        noOfOffices: this.vendor.noOfOffices,
        noOfEmployees: this.vendor.noOfEmployees,
        noOfServicingFacilities: this.vendor.noOfServicingFacilities,
        websiteAddress: this.vendor.websiteAddress,
        authorisedContactName: this.vendor.authorisedContactName,
        phoneNo: this.vendor.phoneNo,
        mobileNo: this.vendor.mobileNo,
        faxNo: this.vendor.faxNo,
        emailAddress: this.vendor.emailAddress,
        notes: this.vendor.notes,
        groupId: this.qmsService.SelectedGroupNameAndValue[0].valueExp,
        ndaSignedDate: vendor.ndaSignedDate ? new Date(this.vendor.ndaSignedDate) : null,
        status: this.selectedStatus ?? null,
        ownershipType: this.selectedOwnerShipType ?? null,
        serviceLevelAgreement: this.selectedServiceLevelAgreement ?? null,
      }

      if (this.operationFlag == 'ADD') {
        this.appService.createQmsVendorsDetails(obj).subscribe({
          next: (Response: any) => {
            if (Response.resultType == "S") {
              this.ngOnInit();
              this.visibleAddAndEditPopup.close();
              this.showSnackBar(Response.result, Response.resultType);
            } else {
              this.isProcessing = false;
              this.showSnackBar(Response.result, Response.resultType);
            }
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      } else {
        const modifiedData = {
          ...obj,
          vendorId: this.previousDataVendorId
        }

        this.appService.updateQmsVendorsDetails(modifiedData).subscribe({
          next: (Response: any) => {
            if (Response.resultType == "S") {
              this.ngOnInit();
              this.visibleAddAndEditPopup.close();
              this.showSnackBar(Response.result, Response.resultType);
            } else {
              this.isProcessing = false;
              this.showSnackBar(Response.result, Response.resultType);
            }
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      }
    }
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  deleteVendorId: any;
  deleteVendorGroupId: any;
  openDeletePopup(deleteRowData: any) {
    console.log(deleteRowData);
    this.operationFlag = 'DELETE';
    this.popupDataTitle.title = "Delete Vendors";
    this.deleteVendorId = deleteRowData.VENDOR_ID;
    this.deleteVendorGroupId = deleteRowData.GROUP_ID;
    this.vendor.deleteReason = '';
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  deleteFunction(vendor: any) {
    if (vendor.deleteReason) {
      this.isProcessing = true;

      const data = {
        vendorId: this.deleteVendorId,
        groupId: this.deleteVendorGroupId,
        deleteReason: this.vendor.deleteReason,
      };

      this.appService.deleteQmsVendorsDetails(data).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            this.ngOnInit();
            this.visibleDeletePopup.close();
            this.showSnackBar(Response.result, Response.resultType);
          } else {
            this.isProcessing = false;
            this.showSnackBar(Response.result, Response.resultType);
          }
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      const field = document.getElementById('delete-text') as HTMLInputElement;
      field.style.color = 'red';
    }
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ? this.message.breadcrumbData.thirdLevel : this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;
  auditTrail: any = {};

  openAuditTrail(viewType: any, vendorMaster: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : vendorMaster.VENDOR_ID;
    this.auditTrail.gridName = 'VENDORS';
    this.auditTrail.report_And_Popup_Name = 'Vendor Master Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(vendorMaster);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = { ...this.reportObj };
    this.excelPdf.reportObj.groupId = this.qmsService.selectedActivityGroupId.toString();
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'Vendor Master Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  htmlContent: any;
  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(list: any, columnName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: columnName
    }
    this.htmlContent = "";
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, columnName);
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
    this.isProcessing = false;
  }

  viewAddress(address: string) {
    this.isProcessing = true;
    this.htmlContent = address;
    this.editorComponent.openEditor(this.htmlContent, 'Address');
    this.isProcessing = false;
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0);
  }

  onChildValueEmitted() {
    this.getCall();
  };

  searchText: any;
  searchValue: any;
  _temp: any = {};
  columnLists: any = {};
  grid: any = [];
  gridTemp: any = [];
  makeStickyColumns: any;
  dataTypeList: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  pager: any = {};
  pagedItems: any[];
  error = '';

  getCall() {
    this.isProcessing = true;
    this.parentCheckBox = false;
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    const data = {

      gridName: "VENDORS",
      groupId: 0
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause = response.orderByClause ? response.orderByClause : "";
        this.makeStickyColumns = response.fixedFieldCnt;
        const data1: any = {

          gridName: "QMS_VENDORS_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          // invisibleColumn: response.invisibleColumn ?? "",
          invisibleColumn: response.invisibleColumn == null ? "" : response.invisibleColumn + ",SERVICES_OFFERED_NAME",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || "",
          groupId: this.qmsService.selectedActivityGroupId.toString()
        }
        this.reportObj = { ...data1, ...data };
        this.auditTrail.secondary_obj = data1;
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.grid = response1;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const element of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }
            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }
            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const element of this.dataTypeList) {
                  if (element.columnName == this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                  }
                }
              }
              for (const rowData of this.grid) {
                for (const element of this.dataTypeList) {
                  if (element.fieldType === 'CHECKBOX') {
                    rowData[element.columnName] = rowData[element.columnName] === 'Y';
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
            });
            this.message.gridList = this.grid;
            this.collectionSize = this.grid.length;
            this.totalPages = Math.ceil(this.grid.length / this.itemsPerPage);
            this.dynamicLabelCall()
            this.isProcessing = false;
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  setPage(page: number, targetPage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.grid.length, page, this.perPage, targetPage);
    this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  setPagedOrSearch(page: number, targetPage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.gridTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.gridTemp.length, page, this.perPage, targetPage);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  columnFilter(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.grid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  searchValue2: any;
  globalFilter(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.gridTemp = this.grid;
      this.pager = this.paginationService.getPager(this.gridTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.grid == undefined) {
        return this.grid;
      }
      if (!this.grid.length) {
        return this.grid;
      }
      if (filter) {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });
      } else {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedOrSearch(1, 0);
    }
  }

  sortedColumn: string = '';
  sortedDisplayColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    this.isProcessing = true;
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortedDisplayColumn = list.fieldColumnarray;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.grid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  counts: any;
  cssFunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {

  }

  parentCheckBox: boolean = false;
  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      for (const element of this.grid) {
        element.childCheckBox = true;
      }
    } else {
      for (const element of this.grid) {
        element.childCheckBox = false;
      }
    }
  }

  previousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.previousSelectedValue != undefined) {
        this.grid[this.previousSelectedValue].childCheckBox = false;
      }
      list.childCheckBox = true;
    } else {
      list.childCheckBox = false;
    }
    this.previousSelectedValue = idx;
  }

  label: any = [];
  dynamicLabel: any = null;
  dynamicLabelCall() {
    this.isProcessing = true;
    const data = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: null,
      gridName: this.reportObj.gridName,
      groupId: this.qmsService.selectedGroupDetailData.groupId,
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (labelResponse: any) => {
        this.label = labelResponse;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  focusSearch(value: any) {
    setTimeout(() => { let searchBox = document.getElementById(value); searchBox?.focus(); }, 0)
  }

  @ViewChild('servicesOffered') servicesOffered: MatSelect;
  isAllServicesOfferedSelected = false;

  toggleAllSelection(value: any) {
    if (value == 'servicesOffered') {
      if (this.isAllServicesOfferedSelected) this.servicesOffered.options.forEach((item: MatOption) => item.select());
      else this.servicesOffered.options.forEach((item: MatOption) => item.deselect());
    }
  }

  public focusEmpty(): void { console.log(); }

}
